import {
  backend_url,
  uninterceptedAxiosInstance,
} from "../common/commonVariables";

  export const exportQRcodes = async (
    modalValues,
    module,
    organisationId = null,
    filters = {},
    id,
    formatType
  ) => {
    try {
      let params = {
        size: modalValues.size,
        module,
        organisation: organisationId,
        filters,
          ...(id ? { id } : {}),
          ...(formatType ? { formatType} : {}),
      };

      const response = await uninterceptedAxiosInstance.post(
        backend_url + "qr-codes-exports",
        { data: params },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
          responseType: "arraybuffer",
        }
      );
      return response;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }

      return {
        status: err?.response?.status,
        error: err?.response?.data?.error,
      };
    }
  };

export const generateQRcode = async (qrData) => {
  try {
    const response = await uninterceptedAxiosInstance.post(
      backend_url + "qr-code/create",
      { qrData },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );
    return response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err?.response?.status,
      error: err?.response?.data?.error,
    };
  }
};
